import { InjectionToken } from '@angular/core';
import { QueryCondition } from '../entity/querycondition';

export interface ListFilterHandler{
    setCurrentFilterConditions(conditions: QueryCondition[]): void;
}

export const LISTFILTER_HANDLER_TOKEN = new InjectionToken<ListFilterHandler>('gsp-cmp/LISTFILTER_HANDLER');